<div *ngIf="config" class="container-block">
  <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>
  
    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div>

  <!-- Cấu hình cơ bản -->
  <ng-container *ngIf="configMode == 'basic'">
    <div style="margin-top: 10px">
       <!-- Set màu nền cho frame blank -->
        <app-background-image-config
          [configFieldName]="'page'"
          [hasConfigGroup]="true"
          [config]="config"
          [class]="class"
          [backgroundClass]="class['page']"
          [backgroundConfig]="config['page']"
          [isPage]="true"
          [id_object]="detailCurrentPage._id"
          [device]="selectedDevice"
          (isCloseConfig)="close()"
          [elementChoosing]="detailCurrentPage"
        >
        </app-background-image-config>
        <div *ngIf="config.page?.option_background == 'color'" class="mr-2 mb-4 mt-4 view-more"
        style="display: flex; align-items: center; justify-content: flex-end; gap: 7px;">
          <p class="discover_text" (click)="openViewAll(style_fields[1])"
            style="cursor: pointer; text-align: left; margin: 0">
            {{'mau_gradient' | translate}} &#8594;
          </p>
        </div>

        <app-borders-config
          [device]="selectedDevice"
          [class]="class"
          [borderClass]="class['page']"
          [id_object]="detailCurrentPage._id"
          (isCloseConfig)="close()"
          [elementChoosing]="detailCurrentPage"
          [isPage]="true"
        >
        </app-borders-config>
       
    </div>
  </ng-container>

  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>
  
  <div class="main config-page" *ngIf="configMode == 'advanced' && !isViewAll">
    <ng-container>
      <!-- Chọn khối header -->
      <p style="margin-bottom: 2px;">{{'chon_header' | translate}}</p>
      <div class="item">
        <nz-select style="width: 100% !important" [(ngModel)]="config.id_block_header"
          (ngModelChange)="updateConfig();" nzPlaceHolder="{{'chon_header_cho_trang' | translate}}">
          <nz-option [nzValue]="''" [nzLabel]="'khong' | translate"></nz-option>
          <ng-container *ngFor="let block of freeblocks" >
            <nz-option *ngIf="block.type == 'header'" [nzValue]="block._id" [nzLabel]="block.name"></nz-option>
          </ng-container>
        </nz-select>
      </div>
      <!-- Chọn khối footer -->
      <p style="margin-bottom: 2px;">{{'chon_footer' | translate}}</p>
      <div class="item">
        <nz-select style="width: 100% !important" [(ngModel)]="config.id_block_footer"
          (ngModelChange)="updateConfig();" nzPlaceHolder="{{'chon_footer_cho_trang' | translate}}">
          <nz-option [nzValue]="''" nzLabel="{{'none' | translate}}"></nz-option>
          <ng-container *ngFor="let block of freeblocks" >
            <nz-option *ngIf="block.type == 'footer'" [nzValue]="block._id" [nzLabel]="block.name"></nz-option>
          </ng-container>
        </nz-select>
      </div>


      <!-- Chọn khối hộp thoại khi tải trang -->
      <div>
        <div class="item">
          <div class="title-font d-flex align-items-center">
            {{'chon_khoi_hop_thoai_khi_tai_trang' | translate}}
          </div>
        </div>
        <div class="item">
          <nz-select
            style="width: 100% !important"
            [(ngModel)]="config.id_block_popup_welcome"
            (ngModelChange)="updateConfig(); "
            nzPlaceHolder="{{'chon_khoi_hop_thoai_khi_tai_trang' | translate}}"
          >
            <nz-option [nzValue]="null" [nzLabel]="'khong' | translate"></nz-option>

            <ng-container *ngFor="let block of freeblocks" >
              <nz-option *ngIf="block.type == 'popup_welcome'" [nzValue]="block._id" [nzLabel]="block.name"></nz-option>
            </ng-container>
          </nz-select>
        </div>

        <!-- Thời gian hiển thị khối hộp thoại tải trang khi tải xong web -->
        <ng-container *ngIf="config.id_block_popup_welcome">
          <div style="gap: 8px;" class="d-flex justify-content-between align-items-center text-justify mb-4">
            <span style="width: 70%;">
              {{'thoi_gian_hien_thi_khoi_hop_thoai_khi_tai_trang_khi_tai_xong_web' | translate}} (s)
            </span>
            <nz-input-number [nzMin]="0" [nzStep]="0.01"
              [ngModel]="(config.duration_hide_popup ?? 3000) / 1000" class="w-50"
              (ngModelChange)="config.duration_hide_popup = $event * 1000"
              (nzBlur)="updateConfig()">
            </nz-input-number>
          </div>
        </ng-container>
      </div>

      <!-- Hộp thoại chứa biểu tượng chat -->
      <div>
        <div class="item">
          <div class="title-font d-flex align-items-center">
           {{'chon_khoi_hop_thoai_chat' | translate}}
          </div>
        </div>
        <div class="item">
          <nz-select
            style="width: 100% !important"
            nzMode="multiple"
            [(ngModel)]="config.id_block_chatboxs"
            (ngModelChange)="updateConfig(); "
            nzPlaceHolder="{{'hop_thoai_chua_bieu_tuong_chat' | translate}}"
          >
            <nz-option [nzValue]="null" [nzLabel]="'khong' | translate"></nz-option>
            <ng-container *ngFor="let block of freeblocks" >
              <nz-option *ngIf="block.type == 'chatbox'" [nzValue]="block._id" [nzLabel]="block.name"></nz-option>
            </ng-container>
          </nz-select>
        </div>
      </div>
    </ng-container>
    <!-- Lựa chọn hiển thị cho các thiết bị -->
    <div class="item">
      <div class="hidden-text" style="display: flex; align-items: center; width: 80%">
        {{'hien_thi_zalo_chat_chi_preview' | translate}}
      </div>
      <nz-switch
        [(ngModel)]="config.zalo_display"
        (ngModelChange)="updateConfig()"
      ></nz-switch>
    </div>
    <!-- Set màu nền cho frame blank -->
    <app-background-image-config
      [configFieldName]="'page'"
      [hasConfigGroup]="true"
      [config]="config"
      [class]="class"
      [backgroundClass]="class['page']"
      [backgroundConfig]="config['page']"
      [isPage]="true"
      [id_object]="detailCurrentPage._id"
      [device]="selectedDevice"
      (isCloseConfig)="close()"
      [elementChoosing]="detailCurrentPage"
    >
    </app-background-image-config>

    <div *ngIf="config.page?.option_background == 'color'" class="mr-2 mb-4 mt-4 view-more"
    style="display: flex; align-items: center; justify-content: flex-end; gap: 7px;">
      <p class="discover_text" (click)="openViewAll(style_fields[1])"
        style="cursor: pointer; text-align: left; margin: 0">
        {{'mau_gradient' | translate}} &#8594;
      </p>
    </div>

    <ul nz-menu nzMode="inline" *ngIf="class">
      <li nz-submenu nzTitle="{{'cau_hinh_thanh_cuon' | translate}}" nzIcon="">
        <!-- Chiều rộng -->
        <div class="row-border">
          <p class="m-0 title-border" style="line-height: 1.5">{{"chieu_rong" | translate}}</p>
          <nz-input-number
            [nzMin]="0"
            [nzStep]="1"
            [ngStyle]="{ marginLeft: '16px', width: '40%' }"
            [ngModel]="resolution[selectedDevice + '_class']?.['scrollbar']?.['width_scrollbar'] | vhnumber"
            (nzBlur)="updateResolution()"
            (ngModelChange)="
              resolution[selectedDevice + '_class']['scrollbar']['width_scrollbar'] = $event + 'px'
            "
          ></nz-input-number>
        </div>
        <nz-row>
          <nz-col nzSpan="24">
            <nz-slider
              [nzMin]="0"
              [nzStep]="1"
              [ngModel]="resolution[selectedDevice + '_class']?.['scrollbar']?.['width_scrollbar'] | vhnumber"
              (nzOnAfterChange)="updateResolution()"
              (ngModelChange)="
                resolution[selectedDevice + '_class']['scrollbar']['width_scrollbar'] = $event + 'px'
              "
            ></nz-slider>
          </nz-col>
        </nz-row>

        <!-- Chiều cao -->
        <div class="row-border">
          <p class="m-0 title-border" style="line-height: 1.5">{{"chieu_cao" | translate}}</p>
          <nz-input-number
            [nzMin]="0"
            [nzStep]="1"
            [ngStyle]="{ marginLeft: '16px', width: '40%' }"
            [ngModel]="resolution[selectedDevice + '_class']?.['scrollbar']?.['height_scrollbar'] | vhnumber"
            (nzBlur)="updateResolution()"
            (ngModelChange)="
              resolution[selectedDevice + '_class']['scrollbar']['height_scrollbar'] = $event + 'px'
            "
          ></nz-input-number>
        </div>
        <nz-row>
          <nz-col nzSpan="24">
            <nz-slider
              [nzMin]="0"
              [nzStep]="1"
              [ngModel]="resolution[selectedDevice + '_class']?.['scrollbar']?.['height_scrollbar'] | vhnumber"
              (nzOnAfterChange)="updateResolution()"
              (ngModelChange)="
                resolution[selectedDevice + '_class']['scrollbar']['height_scrollbar'] = $event + 'px'
              "
            ></nz-slider>
          </nz-col>
        </nz-row>

        <!-- Màu nền nút kéo -->
        <div class="color-pick mb-2">
          <span class="title w-50" style="line-height: 1.3;">{{"nut_keo" | translate}}</span>
          <input class="input-color w-50"
            type="button"
            [cpOKButton]="true" [(colorPicker)]="resolution[selectedDevice + '_class']['scrollbar']['background_color_thumb']"
            [style.background]="resolution[selectedDevice + '_class']['scrollbar']['background_color_thumb']" (colorPickerClose)="updateResolution()"
            [cpWidth]="'230px'"
            />
        </div>

        <div class="color-pick">
          <span class="title w-50" style="line-height: 1.3;">{{"phan_duong_dan" | translate}}</span>
          <input class="input-color w-50"
            type="button"
            [cpOKButton]="true" [(colorPicker)]="resolution[selectedDevice + '_class']['scrollbar']['background_color_track']"
            [style.background]="resolution[selectedDevice + '_class']['scrollbar']['background_color_track']" (colorPickerClose)="updateResolution()"
            [cpWidth]="'230px'"
            />
        </div>

        <!-- Bo tròn nút kéo-->
        <div class="row-border">
          <p class="m-0 title-border" style="line-height: 1.5">{{"bo_tron_nut_keo" | translate}}</p>
          <nz-input-number
            [nzMin]="0"
            [nzStep]="1"
            [nzMax]="10"
            [ngStyle]="{ marginLeft: '16px', width: '40%' }"
            [ngModel]="resolution[selectedDevice + '_class']?.['scrollbar']?.['border_radius_thumb'] | vhnumber"
            (nzBlur)="updateResolution()"
            (ngModelChange)="
              resolution[selectedDevice + '_class']['scrollbar']['border_radius_thumb'] = $event + 'px'
            "
          ></nz-input-number>
        </div>
        <nz-row>
          <nz-col nzSpan="24">
            <nz-slider
              [nzMin]="0"
              [nzStep]="1"
              [nzMax]="10"
              [ngModel]="resolution[selectedDevice + '_class']?.['scrollbar']?.['border_radius_thumb'] | vhnumber"
              (nzOnAfterChange)="updateResolution()"
              (ngModelChange)="
                resolution[selectedDevice + '_class']['scrollbar']['border_radius_thumb'] = $event + 'px'
              "
            ></nz-slider>
          </nz-col>
        </nz-row>

        <!-- Bo tròn phần đường đi -->
        <div class="row-border">
          <p class="m-0 title-border" style="line-height: 1.5">{{"bo_tron_duong_di" | translate}}</p>
          <nz-input-number
            [nzMin]="0"
            [nzStep]="1"
            [nzMax]="10"
            [ngStyle]="{ marginLeft: '16px', width: '40%' }"
            [ngModel]="resolution[selectedDevice + '_class']?.['scrollbar']?.['border_radius_track'] | vhnumber"
            (nzBlur)="updateResolution()"
            (ngModelChange)="
              resolution[selectedDevice + '_class']['scrollbar']['border_radius_track'] = $event + 'px'
            "
          ></nz-input-number>
        </div>
        <nz-row>
          <nz-col nzSpan="24">
            <nz-slider
              [nzMin]="0"
              [nzStep]="1"
              [nzMax]="10"
              [ngModel]="resolution[selectedDevice + '_class']?.['scrollbar']?.['border_radius_track'] | vhnumber"
              (nzOnAfterChange)="updateResolution()"
              (ngModelChange)="
                resolution[selectedDevice + '_class']['scrollbar']['border_radius_track'] = $event + 'px'
              "
            ></nz-slider>
          </nz-col>
        </nz-row>
      </li>
      <li nz-submenu [nzTitle]="'chieu_ngang_thiet_bi' | translate" nzIcon="">
        <div *ngIf="subproject?.desktop_template_display && subproject?.style != 'app'" class="row-border">
          <p class="m-0 title-border" style="line-height: 1.5">{{'may_tinh' | translate}}</p>
          <nz-input-number
            [nzMin]="0"
            [nzStep]="1"
            style="max-width: 100px"
            [(ngModel)]="resolution['desktop_width']"
            (nzBlur)="updateResolution(true)"
          ></nz-input-number>
        </div>
        <div *ngIf="subproject?.tablet_landscape_template_display" class="row-border">
          <p class="m-0 title-border" style="line-height: 1.5">{{'may_tinh_bang_ngang' | translate}}</p>
          <nz-input-number
            [nzMin]="0"
            [nzStep]="1"
            style="max-width: 100px"
            [(ngModel)]="resolution['tablet_landscape_width']"
            (nzBlur)="updateResolution(true)"
          ></nz-input-number>
        </div>
        <div *ngIf="subproject?.tablet_portrait_template_display" class="row-border">
          <p class="m-0 title-border" style="line-height: 1.5">{{'may_tinh_bang_doc' | translate}}</p>
          <nz-input-number
            [nzMin]="0"
            [nzStep]="1"
            style="max-width: 100px"
            [(ngModel)]="resolution['tablet_portrait_width']"
            (nzBlur)="updateResolution(true)"
          ></nz-input-number>
        </div>
        <div *ngIf="subproject?.mobile_landscape_template_display" class="row-border">
          <p class="m-0 title-border" style="line-height: 1.5">{{'dien_thoai_ngang' | translate}}</p>
          <nz-input-number
            [nzMin]="0"
            [nzStep]="1"
            style="max-width: 100px"
            [(ngModel)]="resolution['mobile_landscape_width']"
            (nzBlur)="updateResolution(true)"
          ></nz-input-number>
        </div>
        <div *ngIf="subproject?.mobile_portrait_template_display" class="row-border">
          <p class="m-0 title-border" style="line-height: 1.5">{{'dien_thoai_doc' | translate}}</p>
          <nz-input-number
            [nzMin]="0"
            [nzStep]="1"
            style="max-width: 100px"
            [(ngModel)]="resolution['mobile_portrait_width']"
            (nzBlur)="updateResolution(true)"
          ></nz-input-number>
        </div>
      </li>
      <li nz-submenu [nzTitle]="'gian_cach_giua_cac_khoi' | translate" nzIcon="">
        <ng-container *ngIf="class['layout-grid']">
          <!-- Điều chỉnh row gap -->
          <div class="row-border">
            <p class="m-0 title-border" style="line-height: 1.5">{{'theo_hang' | translate}}</p>
            <nz-input-number
              [nzMin]="0"
              [nzStep]="1"
              [ngStyle]="{ marginLeft: '16px', width: '40%' }"
              [ngModel]="class['layout-grid']['row-gap'] | vhnumber"
              (nzBlur)="updateClass()"
              (ngModelChange)="class['layout-grid']['row-gap'] = $event + 'px'"
            ></nz-input-number>
          </div>
          <nz-row>
            <nz-col nzSpan="24">
              <nz-slider
                [nzMin]="0"
                [nzStep]="1"
                [ngModel]="class['layout-grid']['row-gap'] | vhnumber"
                (nzOnAfterChange)="updateClass()"
                (ngModelChange)="
                  class['layout-grid']['row-gap'] = $event + 'px'
                "
              ></nz-slider>
            </nz-col>
          </nz-row>
          <!-- Điều chỉnh col gap -->
          <div class="row-border">
            <p class="m-0 title-border" style="line-height: 1.5">{{'theo_cot' | translate}}</p>
            <nz-input-number
              [nzMin]="0"
              [nzStep]="1"
              [ngStyle]="{ marginLeft: '16px', width: '40%' }"
              [ngModel]="class['layout-grid']['column-gap'] | vhnumber"
              (nzBlur)="updateClass()"
              (ngModelChange)="
                class['layout-grid']['column-gap'] = $event + 'px'
              "
            ></nz-input-number>
          </div>
          <nz-row>
            <nz-col nzSpan="24">
              <nz-slider
                [nzMin]="0"
                [nzStep]="1"
                [ngModel]="class['layout-grid']['column-gap'] | vhnumber"
                (nzOnAfterChange)="updateClass()"
                (ngModelChange)="
                  class['layout-grid']['column-gap'] = $event + 'px'
                "
              ></nz-slider>
            </nz-col>
          </nz-row>
        </ng-container>
      </li>
      <li nz-submenu [nzTitle]="'canh_le' | translate" nzIcon="">
        <ng-container *ngIf="class['page']">
          <!-- Điều chỉnh padding trên -->
          <div class="row-border">
            <p class="m-0 title-border" style="line-height: 1.5">{{'tren' | translate}}</p>
            <nz-input-number
              [nzMin]="0"
              [nzStep]="1"
              [ngStyle]="{ marginLeft: '16px', width: '40%' }"
              [ngModel]="class['page']['padding-top'] | vhnumber"
              (nzBlur)="updateClass()"
              (ngModelChange)="class['page']['padding-top'] = $event + 'px'"
            ></nz-input-number>
          </div>
          <nz-row>
            <nz-col nzSpan="24">
              <nz-slider
                [nzMin]="0"
                [nzStep]="1"
                [ngModel]="class['page']['padding-top'] | vhnumber"
                (nzOnAfterChange)="updateClass()"
                (ngModelChange)="class['page']['padding-top'] = $event + 'px'"
              ></nz-slider>
            </nz-col>
          </nz-row>
          <!-- Điều chỉnh padding dưới -->
          <div class="row-border">
            <p class="m-0 title-border" style="line-height: 1.5">{{'duoi' | translate}}</p>
            <nz-input-number
              [nzMin]="0"
              [nzStep]="1"
              [ngStyle]="{ marginLeft: '16px', width: '40%' }"
              [ngModel]="class['page']['padding-bottom'] | vhnumber"
              (nzBlur)="updateClass()"
              (ngModelChange)="class['page']['padding-bottom'] = $event + 'px'"
            ></nz-input-number>
          </div>
          <nz-row>
            <nz-col nzSpan="24">
              <nz-slider
                [nzMin]="0"
                [nzStep]="1"
                [ngModel]="class['page']['padding-bottom'] | vhnumber"
                (nzOnAfterChange)="updateClass()"
                (ngModelChange)="
                  class['page']['padding-bottom'] = $event + 'px'
                "
              ></nz-slider>
            </nz-col>
          </nz-row>
          <!-- Điều chỉnh padding trái -->
          <div class="row-border">
            <p class="m-0 title-border" style="line-height: 1.5">{{'trai' | translate}}</p>
            <nz-input-number
              [nzMin]="0"
              [nzStep]="1"
              [ngStyle]="{ marginLeft: '16px', width: '40%' }"
              [ngModel]="class['page']['padding-left'] | vhnumber"
              (nzBlur)="updateClass()"
              (ngModelChange)="class['page']['padding-left'] = $event + 'px'"
            ></nz-input-number>
          </div>
          <nz-row>
            <nz-col nzSpan="24">
              <nz-slider
                [nzMin]="0"
                [nzStep]="1"
                [ngModel]="class['page']['padding-left'] | vhnumber"
                (nzOnAfterChange)="updateClass()"
                (ngModelChange)="class['page']['padding-left'] = $event + 'px'"
              ></nz-slider>
            </nz-col>
          </nz-row>
          <!-- Điều chỉnh padding phải -->
          <div class="row-border">
            <p class="m-0 title-border" style="line-height: 1.5">{{'phai' | translate}}</p>
            <nz-input-number
              [nzMin]="0"
              [nzStep]="1"
              [ngStyle]="{ marginLeft: '16px', width: '40%' }"
              [ngModel]="class['page']['padding-right'] | vhnumber"
              (nzBlur)="updateClass()"
              (ngModelChange)="class['page']['padding-right'] = $event + 'px'"
            ></nz-input-number>
          </div>
          <nz-row>
            <nz-col nzSpan="24">
              <nz-slider
                [nzMin]="0"
                [nzStep]="1"
                [ngModel]="class['page']['padding-right'] | vhnumber"
                (nzOnAfterChange)="updateClass()"
                (ngModelChange)="class['page']['padding-right'] = $event + 'px'"
              ></nz-slider>
            </nz-col>
          </nz-row>
        </ng-container>
      </li>
      <li nz-submenu [nzTitle]="'kieu_vien' | translate" nzIcon="">
        <ng-container *ngIf="class['page']">
          <app-borders-config
            [device]="selectedDevice"
            [class]="class"
            [borderClass]="class['page']"
            [id_object]="detailCurrentPage._id"
            (isCloseConfig)="close()"
            [elementChoosing]="detailCurrentPage"
            [isPage]="true"
          >
          </app-borders-config>

          <!-- <div class="row-border">
            <div
              class="slide-bar d-flex justify-content-between align-items-center"
            >
              <p style="width: 100%" class="m-0 title-border">Bo tròn</p>
              <nz-input-number
                [nzMin]="0"
                [nzMax]="100"
                [ngStyle]="{ marginLeft: '16px', width: '40%' }"
                [ngModel]="class['page']['border-radius'] | vhnumber"
                (nzBlur)="updateClass()"
                (ngModelChange)="class['page']['border-radius'] = $event + 'px'"
              ></nz-input-number>
            </div>
          </div>
          <nz-row>
            <nz-col nzSpan="24">
              <nz-slider
                [ngModel]="class['page']['border-radius'] | vhnumber"
                [nzMin]="0"
                [nzMax]="100"
                [nzStep]="1"
                (nzOnAfterChange)="updateClass()"
                (ngModelChange)="class['page']['border-radius'] = $event + 'px'"
              ></nz-slider>
            </nz-col>
          </nz-row> -->
          <p  class="title-border">{{'bo_tron' | translate}}</p>

          <app-borders-radius-config
          [elementChoosing]="detailCurrentPage" [device]="selectedDevice" [class]="class"
          [borderRadiusClass]="class['page']" [id_object]="detailCurrentPage._id" [isPage]="true">
          </app-borders-radius-config>
        </ng-container>
      </li>
      <!-- Cấu hình hiệu ứng -->
      <li nz-submenu nzTitle="{{'hieu_ung' | translate}}">
        <app-choose-animations-config [elementChoosing]="detailCurrentPage"
          (openAnimationDetail)="openAnimationDetail($event)" [id_object]="detailCurrentPage._id" [device]="selectedDevice"
          [class]="class" [config]="config" [staticdata]="staticdata" [cursorClass]="{}"
          [effect_hover]="effect_hover" [customize]="customize" [effectFileUsing]="'page'">
        </app-choose-animations-config>

        <!-- Thời gian trì hoãn trước khi chạy hiệu ứng -->
        <div *ngIf="config?.['animation-selected']?.['id'] && config['animation-selected']['id'] !== '000000'" claas="mb-4 p-2">
          <div class="row-border">
            <p class="m-0 title-border" style="line-height: 1.5">{{"thoi_gian_tri_hoan_hieu_ung" | translate}} (ms)</p>
            <nz-input-number
              [nzMin]="0" [nzStep]="100" [nzMax]="3000"
              [ngStyle]="{ marginLeft: '16px', width: '40%' }"
              [(ngModel)]="config['animation_delay_page']"
              (nzBlur)="updateConfig()"
            ></nz-input-number>
          </div>
          <nz-row>
            <nz-col nzSpan="24">
              <nz-slider
                [nzMin]="0" [nzStep]="500" [nzMax]="3000"
                [(ngModel)]="config['animation_delay_page']"
                (nzOnAfterChange)="updateConfig()"
              ></nz-slider>
            </nz-col>
          </nz-row>
        </div>
      </li>
    </ul>
  </div>

  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="currentViewAll.index == 1">
      <app-animations-config [elementChoosing]="detailCurrentPage"  [device]="selectedDevice" [isPage]="true"
        [staticdata]="staticdata" [id_object]="detailCurrentPage._id" [customize]="customize">
      </app-animations-config>
    </div>
    <!-- Cấu hình chi tiết màu gradient  -->
    <div class="container-gradient" *ngIf="currentViewAll.index == 2">
      <div class="title-head">
        <p class="text-fill">{{'phoi_mau' | translate}}</p>
        <label nz-checkbox [ngModel]="config['background-color']?.gradient_check"
          (ngModelChange)="config['background-color'].gradient_check = $event; updateBackgroundRgb()"></label>
      </div>
      <ng-container *ngIf="config['background-color']?.gradient_check">
        <div class="list-gradient">
          <button class="btn-gradient" *ngFor="
              let bgGradient of (config['background-color']?.['gradient_arr'] ?? ['rgb(0, 0, 255)', 'rgb(255, 255, 0)']);
              let i = index
            " (click)="deleteGradient(i)" [ngStyle]="{ 'background-color': bgGradient }"
            [disabled]="!config['background-color']?.gradient_check">
            <i class="delete-icon bi bi-x-circle"></i>
          </button>
        </div>
        <p class="title-head">{{'them_mau' | translate}}</p>
        <div class="container_add-gradient">
          <input class="input-color" [cpOKButton]="true" [colorPicker]="config['background-color']?.background"
            type="button" [disabled]="!config['background-color']?.gradient_check"
            [style.background]="config['background-color']?.background" 
            (colorPickerChange)="config['background-color'].background = $event"
            (colorPickerClose)="addGradient($event)" />
        </div>
        <p class="title-head">{{'huong_phoi_mau' | translate}}</p>
        <button class="gradient-direction" *ngFor="let type of functionService.gradientDirectionList" nz-tooltip
          nzTooltipTitle="{{type.name | translate}}" (click)="chooseOption(type, $event)"
          [disabled]="!config['background-color']?.gradient_check"
          [style.background]="'linear-gradient(' + type.deg + ', #2764EB, #EFE810)'"
          [class.active]="config['background-color']?.gradient_direction === type.direction">
        </button>
      </ng-container>
    </div>
  </div>
</div>
